import { Mutation, Action, VuexModule, Module } from 'vuex-class-modules';
import axios from 'axios';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _class, _temp;
var State = {
  INVALID: 0,
  LOADING: 1,
  LOADED: 2
};
var AuthModule = (_class = (_temp =
/*#__PURE__*/
function (_VuexModule) {
  _inherits(AuthModule, _VuexModule);

  function AuthModule() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AuthModule);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AuthModule)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.authInfo = {};
    _this.state = State.INVALID;
    _this.authStateURL = null;
    _this.authLogoutURL = null;
    return _this;
  }

  _createClass(AuthModule, [{
    key: "setAuthInfo",
    value: function setAuthInfo(authInfo) {
      this.authInfo = authInfo;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = state;
    }
  }, {
    key: "setAuthStateURL",
    value: function setAuthStateURL(authStateURL) {
      this.authStateURL = authStateURL;
    }
  }, {
    key: "setAuthLogoutURL",
    value: function setAuthLogoutURL(authLogoutURL) {
      this.authLogoutURL = authLogoutURL;
    }
  }, {
    key: "loggedIn",
    value: async function loggedIn() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ensureLoggedIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force || !this.loaded || ensureLoggedIn && !this.loggedLocally) {
        return this.login(ensureLoggedIn);
      }

      return this.authInfo.logged_in;
    }
  }, {
    key: "getLoginState",
    value: async function getLoginState() {
      // eslint-disable-next-line no-await-in-loop
      var response = await axios.get(this.authStateURL); // if logged in, just return login data to be set by mutation action

      if (response.data.logged_in) {
        this.setAuthInfo(response.data);
        this.setState(State.LOADED);
      }

      return this.loggedLocally;
    }
  }, {
    key: "performLogIn",
    value: async function performLogIn(vue) {
      // set state as loading
      this.setState(State.LOADING); // show the login popup and wait for the it (success or canceled)

      await vue.loginPopup$.waitForLogin();
      return this.loggedLocally;
    }
  }, {
    key: "login",
    value: async function login(vue) {
      var ensureLoggedIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setState(State.LOADING);
      var response = await axios.get(this.authStateURL);
      this.setAuthInfo(response.data);
      this.setState(State.LOADED);

      if (this.loggedLocally) {
        return true;
      }

      if (!ensureLoggedIn) {
        return null;
      }

      return this.performLogIn(vue);
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.state === State.LOADED;
    }
  }, {
    key: "loggedLocally",
    get: function get() {
      return this.loaded && this.authInfo.logged_in;
    }
  }]);

  return AuthModule;
}(VuexModule), _temp), (_applyDecoratedDescriptor(_class.prototype, "setAuthInfo", [Mutation], Object.getOwnPropertyDescriptor(_class.prototype, "setAuthInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setState", [Mutation], Object.getOwnPropertyDescriptor(_class.prototype, "setState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAuthStateURL", [Mutation], Object.getOwnPropertyDescriptor(_class.prototype, "setAuthStateURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAuthLogoutURL", [Mutation], Object.getOwnPropertyDescriptor(_class.prototype, "setAuthLogoutURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loggedIn", [Action], Object.getOwnPropertyDescriptor(_class.prototype, "loggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getLoginState", [Action], Object.getOwnPropertyDescriptor(_class.prototype, "getLoginState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "performLogIn", [Action], Object.getOwnPropertyDescriptor(_class.prototype, "performLogIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "login", [Action], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);

var LoginPopupSupport =
/*#__PURE__*/
function () {
  function LoginPopupSupport(loginURL, popupBlockedCallback, iframeCreator) {
    var _this = this;

    _classCallCheck(this, LoginPopupSupport);

    this._windowCloser = null;
    this._windowCheckInterval = null;
    this._singleShotLoginFinishedListener = [];
    this._loginFinishedListener = [];
    this.loginURL = loginURL;
    this.popupBlockedCallback = popupBlockedCallback;
    this.iframeCreator = iframeCreator; // listen on window messages

    window.addEventListener('message', function (ev) {
      // if the message means finishing openid login in popup
      if (ev.data === 'popup-login-finished') {
        _this._loginFinished(true);
      }
    });
  }

  _createClass(LoginPopupSupport, [{
    key: "addListener",
    value: function addListener(listener) {
      var singleShot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (singleShot) {
        this._singleShotLoginFinishedListener.push(listener);
      } else {
        this._loginFinishedListener.push(listener);
      }
    }
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      this._singleShotLoginFinishedListener = this._singleShotLoginFinishedListener.filter(function (x) {
        return x !== listener;
      });
      this._loginFinishedListener = this._loginFinishedListener.filter(function (x) {
        return x !== listener;
      });
    }
  }, {
    key: "_loginFinished",
    value: function _loginFinished(receivedLoginMessage) {
      var _resolve = [].concat(_toConsumableArray(this._loginFinishedListener), _toConsumableArray(this._singleShotLoginFinishedListener));

      this._singleShotLoginFinishedListener = [];

      this._sendEvent(_resolve, {
        receivedLoginMessage: receivedLoginMessage
      });

      if (this._windowCheckInterval) {
        clearTimeout(this._windowCheckInterval);
        this._windowCheckInterval = null;
      }

      if (this._windowCloser) {
        try {
          // if there is still the popup window, close it
          this._windowCloser();
        } catch (e) {
          console.error(e);
        }

        this._windowCloser = null;
        this._window = null;
      }
    }
  }, {
    key: "_sendEvent",
    value: function _sendEvent(listeners, status) {
      var _this2 = this;

      if (!listeners.length) {
        return;
      }

      var listener = listeners.shift(); // if the result of the listener is a promise wait for it.
      // If not, calling resolve will fire the "then" immediately

      Promise.resolve(listener(status)).then(function (result) {
        // chain the result to the next listener if there is any; if not just use the previous
        // success status
        _this2._sendEvent(listeners, result !== undefined ? Object.assign({}, result, {}, status) : status);
      });
    }
  }, {
    key: "_createLoginWindow",
    value: function _createLoginWindow() {
      var _this3 = this;

      if (this.iframeCreator) {
        this._windowCloser = this.iframeCreator(this.loginURL);
      } else {
        // create the login popup
        var _window = window.open(this.loginURL, '_blank');
        /* , 'width=500,height=500'); */


        if (!_window) {
          console.error('Login popup blocked');

          if (this.popupBlockedCallback) {
            this.popupBlockedCallback();
          }

          this._loginFinished(false);

          return;
        }

        this._windowCloser = function () {
          _window.close();
        }; // listen for window being closed and when this happens finish the login process


        this._windowCheckInterval = setInterval(function () {
          if (_window.closed) {
            _this3._loginFinished(false);
          }
        }, 200);
      }
    }
  }, {
    key: "waitForLogin",
    value: async function waitForLogin() {
      var _this4 = this;

      return new Promise(function (resolve) {
        // , reject
        _this4._singleShotLoginFinishedListener.push(resolve);

        if (!_this4._windowCloser) {
          _this4._createLoginWindow();
        }
      });
    }
  }, {
    key: "startLogin",
    value: function startLogin() {
      this._createLoginWindow();
    }
  }], [{
    key: "install",
    value: function install(Vue, _ref) {
      var loginURL = _ref.loginURL,
          popupBlockedCallback = _ref.popupBlockedCallback,
          iframeCreator = _ref.iframeCreator;
      var inst = new LoginPopupSupport(loginURL, popupBlockedCallback, iframeCreator);
      Vue.prototype.loginPopup$ = inst;
    }
  }]);

  return LoginPopupSupport;
}();

var PopupAuthModule = {
  install: function install(Vue, _ref) {
    var store = _ref.store,
        authStateURL = _ref.authStateURL,
        authLoginURL = _ref.authLoginURL,
        authLogoutURL = _ref.authLogoutURL,
        popupBlockedCallback = _ref.popupBlockedCallback,
        iframeCreator = _ref.iframeCreator,
        _ref$storeModule = _ref.storeModule,
        storeModule = _ref$storeModule === void 0 ? AuthModule : _ref$storeModule,
        _ref$storeModuleOptio = _ref.storeModuleOptions,
        storeModuleOptions = _ref$storeModuleOptio === void 0 ? {} : _ref$storeModuleOptio;
    Vue.use(LoginPopupSupport, {
      popupBlockedCallback: popupBlockedCallback,
      iframeCreator: iframeCreator,
      loginURL: authLoginURL
    });
    var module = Module(storeModule); // eslint-disable-next-line

    var authModule = new module(Object.assign({
      store: store,
      name: 'auth'
    }, storeModuleOptions));
    authModule.setAuthStateURL(authStateURL);
    authModule.setAuthLogoutURL(authLogoutURL);
    Vue.prototype.auth$ = authModule;
    Vue.prototype.$auth = authModule;
    Vue.prototype.loginPopup$.addListener(authModule.getLoginState, false);
    this.store = authModule;
  }
};

export default PopupAuthModule;
export { AuthModule, LoginPopupSupport };
